import { put, call } from 'redux-saga/effects';
import { Types } from './actions';
import IDHelpers from '../../../../core/helpers/IDHelper';
import ExamsDataRepository from '../../../../data/repositories/ExamsDataRepository';
import ExamsRepository from '../../../repositories/ExamsRepository';
import constants from '../../../../core/constants';
import buildings from './buildings.json';

export const extractCampusAndSede = (inputString: string) => {
  const parts = inputString.split(' - ');

  let campus = null;
  let sede = null;

  Object.values(parts).forEach((part: string) => {
    if (part.startsWith('Campus')) {
      campus = part.replace('Campus ', '').trim();
    } else if (part.startsWith('Sede')) {
      sede = part.replace('Sede ', '').trim();
    }
  });
  return { campus, sede };
};

export function* getExams(period: string): any {
  const examsRepository: ExamsRepository = new ExamsDataRepository();
  const examsResponse = yield call(examsRepository.getExams, period);
  return (examsResponse?.scheduleV2 || []).map((e: any) => {
    const buildingInformation = buildings.find(
      (building) => building.id === e.building
    );

    const { campus, sede } = extractCampusAndSede(
      buildingInformation?.description ?? ''
    );

    return {
      building: {
        address: buildingInformation?.address?.toLowerCase() ?? '-',
        campus: campus ?? '-',
        sede: sede ?? '-',
        description: buildingInformation?.description?.toLowerCase() ?? '-',
        coordinates: buildingInformation?.coordinates
      },
      buildingId: e.building,
      classNbr: e.classNbr,
      address: e.address,
      date: e.date + constants.MIL_PERU,
      description: e.desc,
      end: e.endTime + constants.MIL_PERU,
      eventId: IDHelpers.generateID(),
      idZoom: e.link || '',
      name: e.name?.toLowerCase() || '-',
      room: e.roomInformation,
      roomId: e.room,
      start: e.startTime + constants.MIL_PERU,
      location: { classRoom: { id: e.room } },
      type: 'E',
      typeMod: e.typeMod,
      modality: e.typeMod,
      instructionMode: e.typeMod
    };
  });
}

export default function* execute(action: any): any {
  try {
    yield put({ type: Types.GET_EXAMS_REQUEST });
    const exams: any[] = yield getExams(action.period);

    const data = {
      exams
    };

    yield put({ type: Types.GET_EXAMS_SUCCESS, data });
  } catch (error) {
    yield put({
      type: Types.GET_EXAMS_FAILURE,
      error: 'Ocurrió un error'
    });

    throw error;
  }
}
